import { Actions, ActionToAttributes, ActionType, Colours, DEFENSE_WON_RESULTS, DRAW_RESULTS, PASS_SUCCESSFUL_RESULTS, RoundResult, RoundState, TeamState } from "@alienheadwars/football-card-manager-model";
import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { localise } from "../../../../../locale/locale";
import { Icon, IconId } from "../../../../base/icon/Icon";
import { InLine } from "../../../../cards/playerCards/CardDimensions";
import { ExpandablePlayerCard } from "../../../../cards/playerCards/ExpandablePlayerCard";
import { AnimatedStack } from "../../../../MotionMui/MotionMui";
import { CommentaryCard } from "./CommentaryCard";
import { ContestCommentaryComponent } from "./ContestCommentary";
import { PlayerEventCommentaries } from "./PlayerEventCommentary";



export const RoundCurrentCommentaryComponent = (props: RoundCommentaryProps) => {
    if (props.showResult) {
        return <CompletedRoundCommentaryComponent {...props} />
    }
    else {
        return <InProgressRoundCommentaryComponent {...props} />
    }
}

export interface RoundCommentaryProps {
    roundState: RoundState;
    teams: {
        [key: string]: TeamState;
    },
    showResult: boolean,
    live: boolean
    showContest1: boolean,
    showContest2: boolean,
    homeTeam: string,
}

export const RoundDescriptionCommentaryComponent = (props: RoundCommentaryProps) => {
    return <AnimatedStack spacing={0} >
        {props.showResult && <CompletedRoundCommentaryComponent {...props} />}
        {props.showResult && <PlayerEventCommentaries {...props} />}
        {props.showContest2 && props.roundState.contests.length > 1 && <ContestCommentaryComponent {...props} contest={props.roundState.contests[1]} />}
        {props.showContest1 && props.roundState.contests.length > 0 && <ContestCommentaryComponent {...props} contest={props.roundState.contests[0]} />}
        <InProgressRoundCommentaryComponent {...props} />
    </AnimatedStack>
}


export const RoundFullCommentaryComponent = (props: RoundCommentaryProps) => {
    return <AnimatedStack spacing={0} >
        {props.showResult && <CompletedRoundCommentaryComponent {...props} />}
        {props.showResult && <PlayerEventCommentaries {...props} />}
        {props.showContest2 && props.roundState.contests.length > 1 && <ContestCommentaryComponent {...props} contest={props.roundState.contests[1]} />}
        {props.showContest1 && props.roundState.contests.length > 0 && <ContestCommentaryComponent {...props} contest={props.roundState.contests[0]} />}
        <InProgressRoundCommentaryComponent {...props} />
    </AnimatedStack>
}

const CompletedRoundCommentaryComponent = (props: RoundCommentaryProps) => {
    const defenseWon = DEFENSE_WON_RESULTS.includes(props.roundState.roundResult!)
    const colours = (defenseWon ?
        props.teams[props.roundState.defendingTeam].colours :
        props.teams[props.roundState.attackingTeam].colours
    ) ?? defaultColours
    const [dynamicColours, setDynamicColours] = useState(colours)

    useEffect(() => {
        if (props.live && props.showResult && props.roundState.roundResult === RoundResult.GOAL) {
            let count = 0;
            const goalBackgroundColour = colours.primaryColour
            const backgroundColour = colours.primaryBackgroundColour

            const interval = setInterval(() => {
                setDynamicColours({ ...colours, primaryBackgroundColour: count % 2 === 0 ? goalBackgroundColour : backgroundColour });
                count++;
            }, 250);
            setTimeout(() => {
                clearInterval(interval);
                setDynamicColours(colours);
            }, 3000);
        }
    }, [colours, props.live, props.roundState.roundResult, props.showResult]
    )

    const iconId: IconId = defenseWon ? props.roundState.action === Actions.STALL ? 'STALL' : (ActionToAttributes[props.roundState.action!]![ActionType.DEFENSE]).toUpperCase() as IconId :
        DRAW_RESULTS.includes(props.roundState.roundResult!) ? 'BALANCE' :
            props.roundState.action as IconId
    const roundWinner = <ExpandablePlayerCard player={
        //If defense won, grab the last defender
        (defenseWon ? props.roundState.defendingHand[props.roundState.contests.length === 2 ? props.roundState.contests[1].defendingPlayerIndex :
            props.roundState.contests.length === 1 ? props.roundState.contests[0].defendingPlayerIndex :
                props.roundState.defendingPlayer ?? 0] :
            //optherwise use the attacking player
            props.roundState.attackingHand[PASS_SUCCESSFUL_RESULTS.includes(props.roundState.roundResult!) ? props.roundState.attackingTargetPlayer! : props.roundState.attackingPlayer!])
            .playerDetails
    } dimensions={InLine} />

    const roundResult = localise(`commentary.roundresult.${props.roundState.roundResult!}`)

    return <CommentaryCard colours={dynamicColours}>
        <Box sx={{ padding: '1vmin' }}>
            <Icon iconId={iconId} primaryColor={colours.primaryTextColour} secondaryColor={colours.primaryBackgroundColour} fontSize="small" />
        </Box> {roundWinner}
        <CommentaryTypography>{roundResult}</CommentaryTypography>
    </CommentaryCard>
}



const InProgressRoundCommentaryComponent = (props: RoundCommentaryProps) => {
    const colours = props.teams[props.roundState.attackingTeam].colours ?? defaultColours

    const playerOnBall = props.roundState.attackingPlayer !== undefined ? <ExpandablePlayerCard player={props.roundState.attackingHand[props.roundState.attackingPlayer].playerDetails} dimensions={InLine} />
        : `${props.teams[props.roundState.attackingTeam].name} ${localise('commentary.kickoff')}`

    const iconId = props.roundState.attackingPlayer === undefined ? "WHISTLE" :
        props.roundState.action ? props.roundState.action as IconId :
            'WAITING'

    const action = props.roundState.attackingPlayer === undefined ? <></> :
        props.roundState.action ? localise(`commentary.pendingAction.${props.roundState.action}`)
            : localise('commentary.pendingAction.noAction')

    return <CommentaryCard colours={colours} >
        <Box sx={{ padding: '1vmin' }}>
            <Icon iconId={iconId} primaryColor={colours.primaryTextColour} secondaryColor={colours.primaryBackgroundColour} fontSize="small" />
        </Box>
        {playerOnBall}
        <CommentaryTypography > {action}</CommentaryTypography>
    </CommentaryCard>
}
const CommentaryTypographyProps = {
    component: "div",
    sx: {
        // color: colours.primaryTextColour,
        // textAlign: 'center',
        fontSize: InLine.playerNameFontSize,
        paddingLeft: InLine.playerNameBackgroundPadding
    }
}
const CommentaryTypography = (props: { children: React.ReactNode }) => {
    return <Typography {...CommentaryTypographyProps}> {props.children}</Typography>
}

const defaultColours: Colours = {
    primaryBackgroundColour: 'white',
    secondaryColour: 'grey',
    primaryTextColour: 'black',
    primaryColour: 'grey'

}